export interface IAttachment {
  accessRecipientNames?: string[];
  accessRecipientList?: string[];
  attachmentDescription: string;
  attachmentExtension?: string;
  attachmentId?: string;
  attachmentFilename: string;
  attachmentSha?: string;
  attachmentTitle: string;
  attachmentType: EnumAttachmentTypes;
  attachmentUrl: string;
  attachmentSize?: number;
  lastAttachmentView?: Date;
  thumbUrl?: string;
  requireView?: boolean;
  restrictAccess?: boolean;
  hashId?: string;
  id?: string;
}

export enum EnumAttachmentTypes {
  Upload = 'upload',
  File = 'file',
  External = 'external',
  Document = 'document',
}
